/*
  Announcement bar marquee / play-pause behaviour — extracted from
  sections/announcement-bar.liquid so it ships from a cacheable, deferred asset instead of ~4KB
  of inline script.

  The section's id was baked into the element lookup; init() now takes the root element and is
  run for every `[data-section-type="announcement-bar"]` on the page, still guarded by the
  existing data-annbar-init flag so repeat calls are no-ops.
*/
(function () {
  function init(rootElement) {
    var root = rootElement;
    if (!root || root.dataset.annbarInit === '1') return;
    root.dataset.annbarInit = '1';

    var middle = root.querySelector('.announcement-bar__middle');
    if (!middle) return;

    function isVisible(el) {
      var r = el.getBoundingClientRect();
      return r.top < (window.innerHeight || document.documentElement.clientHeight) && r.bottom > 0;
    }
    function hasMultiple() {
      return !!root.querySelector('.announcement-bar__announcements .announcement + .announcement');
    }
    function kickPlayIfNeeded() {
      if (root.dataset.annbarState === 'paused') return;
      if (!hasMultiple()) return;
      if (!isVisible(root)) return;
      middle.dispatchEvent(new Event('focusout', { bubbles: true }));
    }

    function focusoutBlocker(e) {
      if (root.dataset.annbarState === 'paused') {
        e.stopImmediatePropagation();
      }
    }

    function getState() {
      return root.dataset.annbarState === 'paused' ? 'paused' : 'playing';
    }

    function syncButtons(state) {
      var isPlaying = state === 'playing';
      root.querySelectorAll('.nav-toggle').forEach(function (btn) {
        btn.dataset.state = state;
        btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        btn.setAttribute('aria-label', isPlaying ? 'Pause slideshow' : 'Play slideshow');
      });
    }

    function syncMarquee(state) {
      var isPlaying = state === 'playing';
      root.querySelectorAll('.marquee .marquee-content').forEach(function (track) {
        if (isPlaying) track.style.removeProperty('animation-play-state');
        else track.style.animationPlayState = 'paused';
      });
    }

    function pauseThemeRotation() {
      middle.dispatchEvent(new Event('focusin', { bubbles: true }));
      // block natural focusout events (from button clicks) from re-starting while paused
      middle.addEventListener('focusout', focusoutBlocker, true);
    }

    function playThemeRotation() {
      middle.removeEventListener('focusout', focusoutBlocker, true);
      middle.dispatchEvent(new Event('focusout', { bubbles: true }));
    }

    function setState(state) {
      root.dataset.annbarState = state;
      syncButtons(state);
      syncMarquee(state);
      if (state === 'playing') playThemeRotation();
      else pauseThemeRotation();
    }

    var initial = root.querySelector('.nav-toggle[data-state="paused"]') ? 'paused' : 'playing';
    setState(initial);

    requestAnimationFrame(function () {
      setTimeout(kickPlayIfNeeded, 0);
      setTimeout(kickPlayIfNeeded, 200);
    });
    window.addEventListener('load', kickPlayIfNeeded, { once: true });

    if ('IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === root && entry.isIntersecting && !started) {
            started = true;
            kickPlayIfNeeded();
            io.disconnect();
          }
        });
      }, { threshold: 0.01 });
      io.observe(root);
    }

    // event delegation for all toggles 
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.nav-toggle');
      if (!btn || !root.contains(btn)) return;
      setState(getState() === 'playing' ? 'paused' : 'playing');
    });

    root.addEventListener('keydown', function (e) {
      var btn = e.target.closest('.nav-toggle');
      if (!btn || !root.contains(btn)) return;
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        setState(getState() === 'playing' ? 'paused' : 'playing');
      }
    });

    document.addEventListener('shopify:section:load', function (evt) {
      if (evt.target && evt.target.id === root.id) {
        setState(getState());
        requestAnimationFrame(kickPlayIfNeeded);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="announcement-bar"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  window.addEventListener('pageshow', initAll);
})();
